import { 
    getAuth, 
    onAuthStateChanged, 
    signInWithEmailAndPassword,
    createUserWithEmailAndPassword,
    signOut
  } from 'firebase/auth';
import { createContext, useContext, useEffect, useState } from 'react';
import { appp } from './firebase';


  // Create auth context
  export const AuthContext = createContext();
  
  // Custom hook to use the auth context
  export const useAuth = () => {
    return useContext(AuthContext);
  };
  
  // Auth Provider component
  export const AuthProvider = ({ children }) => {
    const [currentUser, setCurrentUser] = useState(null);
    const [loading, setLoading] = useState(true);
    const auth = getAuth(appp)
  
    // Function to handle login
    const login = (email, password) => {
      return signInWithEmailAndPassword(auth, email, password);
    };
  
    // Function to handle signup
    const signup = (email, password) => {
      return createUserWithEmailAndPassword(auth, email, password);
    };
  
    // Function to handle logout
    const logout = () => {
      return signOut(auth);
    };
  
    // Listen for auth state changes
    useEffect(() => {
      const unsubscribe = onAuthStateChanged(auth, (user) => {
        setCurrentUser(user);
        setLoading(false);

        console.log(user)
      });
  
      // Cleanup subscription
      return unsubscribe;
    }, [auth]);
  
    const value = {
      currentUser,
      login,
      signup,
      logout,
      isAuthenticated: !!currentUser
    };
  
    return (
      <AuthContext.Provider value={value}>
        {!loading && children}
      </AuthContext.Provider>
    );
  };